const TableStyles = {
  Container: {
    backgroundColor: "#ffffff",
    padding: "1rem",
    boxShadow: "none",
    margin: "30px 0",
  },
  THFont: {
    color: "#4f4e4ede",
    fontWeight: "bold",
    fontSize: "1rem",
  },
};

export default TableStyles;
